/** @file Creates a named event with default int, float and string payloads. */
import { z } from 'zod';
import { prim } from '@pose2d/format/doc/schemaParts/primitives';
import { defineCreate } from '../_shared/defineCreate';

/** event.create: the defineCreate factory with int/float/string payload defaults. */
export const command = defineCreate({
  domain: 'event',
  kind: 'event',
  description: 'Create an event; its keys fire it with these defaults (int 0, float 0, string "") unless a key overrides them.',
  schema: z
    .object({ id: z.string().exactOptional(), name: z.string().min(1), int: z.number().int().default(0), float: prim.finite.default(0), string: z.string().default('') })
    .strict(),
  build: (input) => ({ name: input.name, int: input.int, float: input.float, string: input.string }),
});
